module.exports = function() {
  return new Worker(__webpack_public_path__ + "8020c1443bf3438d7d9e.worker.js");
};